import { SubscriptionNameEnum } from 'shared-enums/subscription'

import type { SubscriptionByName, SubscriptionDisplayPrice } from 'shared-types/subscription'

export const nameBySubscription: SubscriptionByName<string> = {
  [SubscriptionNameEnum.PROFESSIONAL]: 'Pro',
  [SubscriptionNameEnum.ENTERPRISE]: 'Entreprise'
}

export const priceBySubscription: SubscriptionByName<number> = {
  [SubscriptionNameEnum.PROFESSIONAL]: 20,
  [SubscriptionNameEnum.ENTERPRISE]: 35
}

export const displayPriceBySubscription: SubscriptionByName<SubscriptionDisplayPrice> = {
  [SubscriptionNameEnum.PROFESSIONAL]: `Fr. ${priceBySubscription[SubscriptionNameEnum.PROFESSIONAL]}.-`,
  [SubscriptionNameEnum.ENTERPRISE]: `Fr. ${priceBySubscription[SubscriptionNameEnum.ENTERPRISE]}.-`
}
